module.exports = __webpack_public_path__ + "img/activity.33e1039b.png";